import { create } from "zustand";
import { persist } from "zustand/middleware";

export type WorkspaceFilterScope = "deployment" | "team" | "project";
export interface WorkspaceFilterSelection {
  scope: WorkspaceFilterScope;
  teamId: string;
  projectId: string;
}

interface WorkspaceFilterMemory {
  pageScopes: Record<string, WorkspaceFilterScope>;
  lastTeamId: string | null;
  lastProjectSelection: { teamId: string; projectId: string } | null;
}

export const useWorkspaceFilterStore = create(
  persist<
    WorkspaceFilterMemory & {
      remember: (pathname: string, selection: WorkspaceFilterSelection) => void;
      clear: () => void;
    },
    [],
    [],
    WorkspaceFilterMemory
  >(
    (set) => ({
      pageScopes: {},
      lastTeamId: null,
      lastProjectSelection: null,
      remember: (pathname, selection) =>
        set((state) => {
          const lastTeamId = selection.scope === "team" ? selection.teamId : state.lastTeamId;
          const lastProjectSelection = selection.scope === "project" ? { teamId: selection.teamId, projectId: selection.projectId } : state.lastProjectSelection;
          return state.pageScopes[pathname] === selection.scope &&
            state.lastTeamId === lastTeamId &&
            state.lastProjectSelection?.teamId === lastProjectSelection?.teamId &&
            state.lastProjectSelection?.projectId === lastProjectSelection?.projectId
            ? state
            : { pageScopes: { ...state.pageScopes, [pathname]: selection.scope }, lastTeamId, lastProjectSelection };
        }),
      clear: () => set({ pageScopes: {}, lastTeamId: null, lastProjectSelection: null }),
    }),
    {
      name: "workspaceFilters",
      version: 1,
      partialize: ({ pageScopes, lastTeamId, lastProjectSelection }) => ({ pageScopes, lastTeamId, lastProjectSelection }),
      migrate: () => ({ pageScopes: {}, lastTeamId: null, lastProjectSelection: null }),
    },
  ),
);
